import React, { ChangeEvent } from "react"
import { ChevronRightIcon } from "@heroicons/react/24/outline"

type SearchInputType = {
  label: string
  handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void
  searchInput: string
  searchResultCount: number
}

const SearchInput = ({
  handleInputChange,
  searchInput,
  searchResultCount,
  label,
}: SearchInputType) => {
  const inputId = `${label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")}-input`
  const countId = `${inputId}-count`
  const resultNoun = label.toLowerCase().includes("publication")
    ? searchResultCount === 1
      ? "publication"
      : "publications"
    : searchResultCount === 1
    ? "software project"
    : "software projects"

  return (
    <div className="search-field">
      <label className="sr-only" htmlFor={inputId}>
        {label}
      </label>
      <ChevronRightIcon aria-hidden="true" className="search-field__prompt" />
      <input
        id={inputId}
        type="search"
        className="search-field__input"
        placeholder={`${label}…`}
        aria-describedby={countId}
        onChange={handleInputChange}
        value={searchInput}
      />
      <span
        id={countId}
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {searchResultCount} {resultNoun}
      </span>
    </div>
  )
}

export default SearchInput
